import type { Category } from '../query';

const events = {
  financial: 'chart05',
  strategy: 'chart04',
  dividend: 'good',
  other: 'chart01',
  management: 'chart02',
} as const;

export const getCategoryColor = (category: Category) => {
  if (category in events) {
    return events[category];
  }
  return 'white';
};
